import { nanoid } from "nanoid";
import React from "react";
import { Component } from "react";
// import { Modal } from "react-bootstrap";
import { translate } from "../../utils/useful";
// import FixedView from "../FixedView";
// import Modal from "../Modal";
// import inputComponents from "./inputComponents";
// import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../utils/functions";
// import SidebarView from "../SidebarView";
import FilterItems from "./FilterItems";
// import SaveFilter from './SaveFilter'
// import LoaderButton from "../LoaderButton";
// import ButtonAnimated from "../buttons/ButtonAnimated";



class FilterEditorInput extends Component {
    state = {

        baseData: {
            root: {
                id: 'root',
                action: 'and',
                conditions: {}
            }
        },

        data: {},

        tempData: {},
        // columns: [],


        inputHeader: {
            type: 'TextInput'
        },

        items: [],
        // { item: '{{lang}}Name', src: '/assets/icons/name.svg' },
        // { item: '{{lang}}Priority', src: '/assets/icons/priority.svg' },
        // { item: '{{lang}}Flagged', src: '/assets/icons/flagged.svg' },
        // { item: '{{lang}}Assignee', src: '/assets/icons/assignee.svg' },
        // { item: '{{lang}}Start date', src: '/assets/icons/calendar.svg' },
        // { item: '{{lang}}Date', src: '/assets/icons/calendar.svg' }

        // condition: [
        //     { item: 'contains' },
        //     { item: 'does not contain' },
        //     { item: 'is' },
        //     { item: 'is not' },
        //     { item: 'is empty' },
        //     { item: 'is not empty' }
        // ],
        slectedCell: [],
        labela: '',
        calca: '',
        selectedChoose: false,
        selectedCalc: false,
        // calc: [
        //     { title: '{{lang}}Equal', value: 'Equal' },
        //     { title: '{{lang}}Less Than', value: 'Less Than' },
        //     { title: '{{lang}}More Than', value: 'More Than' },
        //     { title: '{{lang}}Equal of less than', value: 'Equal of less than' },
        //     { title: '{{lang}}Equal of more than', value: 'Equal of more than' },
        //     { title: '{{lang}}Contains', value: 'Contains' },
        // ],
        // save: [
        //     { name: 'test', image: "/assets/icons/more-black.svg" },
        //     { name: 'number', image: "/assets/icons/more-black.svg" },
        //     { name: 'test2', image: "/assets/icons/more-black.svg" },
        //     { name: 'heiskj', image: "/assets/icons/more-black.svg" }
        // ]
    }

    componentDidMount() {

        this.init()

    }


    componentDidUpdate(prevProps, prevState) {

        if (prevProps.params != this.props.params) {
            this.init()
        }
        // console.log(this.props.data)

        if (prevProps.data != this.props.data) {

            // if (!prevProps.data && prevProps.data != this.props.data) {
            this.init()
        }
    }


    init() {

        // console.log("INIT", this.props.data)
        let current = { level: 0, groupId: 'root', parents: [] }


        // if (this.props.data  ) {
        let data = this.props.data
        if (!data?.root) {
            data = JSON.parse(JSON.stringify(this.state.baseData))
        }
        this.setState({ data }, () => {

            // console.log(this.state.current)

            if (this.state.data?.root?.conditions && Object.keys(this.state.data?.root?.conditions).length == 0) {
                this.doAdd('con', current)
            }

        })
        // } else {
        //     if (Object.values(this.state.data).length == 0) {
        //         this.setState({ current, data: this.state.baseData }, () => {
        //             this.doAdd('con', current)
        //         })
        //     }
        // }

        // console.log(this.props.data)

        this.setState({ items: this.props.params }, () => {
        });


        // let element
        // for (let i = 0; i < this.props.params?.length; i++) {
        //     element = this.props.params[i];

        //     console.log(element)
        //     this.setState({ slectedCell: element }, () => {
        //     })
        // }
    }



    // saveAction = () => {
    //     this.saveSidebar.open()
    // }

    // selectHandler = (item) => {
    //     let items = this.state.items
    //     items.push(item)
    // }

    // doDone = () => {
    //     this.setState({ tempData: -1 }, () => {
    //         this.props.changeValue(this.props.header?.key, this.state.data, this.props.extra)
    //     })
    // }

    // openAdd = (id, parents, level) => {
    //     this.setState({ currentNode: this['add-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.fixedView.showView()
    //     })
    // }

    // openActionsView = (id, parents, level) => {
    //     this.setState({ currentNode: this['action-' + id], current: { level, groupId: id, parents } }, () => {
    //         this.actionsView.showView()
    //     })
    // }

    doAdd = (type, current) => {
        if (this.fixedView) {
            this.fixedView.hideView()
        }
        let id = nanoid(10)

        let newCondition
        if (type == 'con') {
            newCondition = { id, source: null, operator: 'Equal', target: null }
        } else {
            let newId = nanoid()
            newCondition = { id, action: 'and', conditions: { [newId]: { id: newId } } }
        }
        let data = this.state.data
        // let current = this.state.current
        current.id = id

        // console.log(newCondition)
        this.actionOnChild(data, current, newCondition, 'add', 0)


        this.setState({ data: data })
    }

    // changeAction = (type) => {

    //     let data = this.state.data
    //     let current = this.state.current
    //     this.actionOnChild(data, current, type, 'changeOperator', 0)
    //     this.setState({ data })
    //     if (this.actionsView) {
    //         this.actionsView.hideView()
    //     }
    // }

    removeRow = (groupId, id, parents) => {
        let current = { groupId, id, parents }
        let data = this.state.data
        this.actionOnChild(data, current, null, 'remove', 0)

        if (typeof data == 'object' && Object.values(data).length == 0) {
            data = null
        }

        // console.log("removeRow", data)
        // console.log("removeRow1", groupId, id, parents)

        this.setState({ data: data }, () => {
            this.props.changeValue((this.props.header?.key ?? 'data'), data)
        })

    }

    // openInput = (key, id, groupId, parents) => {
    //     let current = { groupId, id, parents, key }
    //     let data = this.state.data
    //     let value = this.actionOnChild(data, current, null, 'get', 0)

    //     let inputHeader = {
    //         type: 'SmartInput'
    //         , information: {}
    //     }

    //     if (key == 'operator') {
    //         inputHeader = {
    //             type: 'SelectInput', information: {
    //                 type: 'local', items: [
    //                     { title: '{{lang}}Equal', value: 'Equal' },
    //                     { title: '{{lang}}Less Than', value: 'Less Than' },
    //                     { title: '{{lang}}More Than', value: 'More Than' },
    //                     { title: '{{lang}}Equal or less than', value: 'Equal of less than' },
    //                     { title: '{{lang}}Equal or more than', value: 'Equal of more than' },
    //                     { title: '{{lang}}Contains', value: 'Contains' },
    //                 ]
    //             }
    //         }
    //     }

    //     this.setState({ inputHeader, currentNode: this[key + '-' + id], current: { id, groupId, parents, key, value } }, () => {
    //         this.inputView.showView()
    //     })
    // }

    setLastClicked = (id) => {
        this.setState({ lastClicked: id })
    }

    changeInputValue = (key, value, current, extra) => {

        // let current = this.state.current
        let data = this.state.data
        // let value = target.value

        this.actionOnChild(data, current, value, 'update', 0)
        current.value = value//target.value

        this.setState({ data, current }, () => {
            this.props.changeValue((this.props.header?.key ?? 'data'), data, this.props.extra)
            // this.props.changeValue(this.props.header?.key, data, this.props.extra)
        })
    }

    actionOnChild(data, current, value, action, index, cb) {
        // console.log("actionOnChild", index, current.parents.length)
        if (index == current.parents.length) {

            if (action == 'add') {

                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                if (!data[current.groupId].conditions) {
                    data[current.groupId].conditions = {}
                }
                data[current.groupId].conditions[current.id] = value

            }

            if (action == 'remove') {
                // console.log("remove ",data)

                if (current.id == null) {
                    // console.log("remove Tp1")

                    delete data[current.groupId]
                    data = null
                    // console.log("remove", data)
                    return data
                } else {
                    // console.log("remove Tp2")

                    delete data[current.groupId].conditions[current.id]

                    // console.log("1",Object.values(data[current.groupId].conditions).length)

                    if (Object.values(data[current.groupId].conditions).length == 0) {

                        // console.log("remove Tp4")

                        delete data[current.groupId]
                        data = null
                    }
                    // console.log(current.groupId, data)
                    return data
                }
            }

            if (action == 'changeOperator') {
                if (!data[current.groupId]) {
                    data[current.groupId] = {}
                }
                data[current.groupId].action = value
            }

            if (action == 'update') {
                data[current.groupId].conditions[current.id][current.key] = value
            }

            if (action == 'get') {
                return data[current.groupId].conditions[current.id][current.key]
            }

        } else if (index < current.parents.length) {
            let newData = data[current.parents[index]]
            console.log("Tp3")
            if (newData) {
                return this.actionOnChild(newData.conditions, current, value, action, index + 1)
            }
        }
    }

    // getLabel(prop, key) {
    //     let label = prop[key]
    //     let hasValue = true
    //     if (!label) {
    //         label = translate('Choose')
    //         hasValue = false
    //     }
    //     return { label, hasValue }
    // }

    // setData = (item) => {
    //     this.setState({ labela: item, selectedChoose: true, selectedCalc: true, calca: item })
    // }

    // openSecondView = () => {
    //     // let current = { groupId: this.props.data.id, id: this.props.prop.id, key: 'action', parents: this.props.parents }
    //     // if (this.props.setCurrent) {
    //     //     this.props.setCurrent('current', current)
    //     // }
    //     this.secondView.showView();
    // };

    renderGroup(data, parents, level) {
        if (data) {
            return (
                <div className="position-relative">
                    {/* {data.action && (
                        <div className="flexcb" style={{ justifyContent: 'right' }}>
                            {level != 0 && (
                                <>
                                    <button onClick={() => this.removeRow(data.id, null, parents, level)} className=" flexcc" style={{ position: "absolute", top: 17, left: 0.5, backgroundColor: "#f6f6f6", width: 12, height: 12, borderRadius: 3 }} >
                                        <p className="flexcc" style={{ color: "#FF3B30" }}>&times;</p>
                                    </button>
                                </>
                            )}
                        </div>
                    )} */}
                    <div className="" style={{ backgroundColor: "transparent" }}>

                        {/* <button ref={(el) => (this.secondCurrentNode = el)} onClick={() => this.openSecondView()} className="flexcb px-2" style={{ flex: "1 1 0", height: '30px', background: '#fff', color: '#000', gap: ".1em", border: '1px solid rgba(0,0,0,0.1)', borderRadius: 7 }}>
                            <span className="text-smaller">{this.state.data.action ?? "and"}</span>
                            {this.props.index == 0 ?
                                <img className="" style={{ opacity: 0.8 }} src="/assets/icons/down-arrow.svg" width="8px" />
                                :
                                <img className="" style={{ opacity: 0 }} src="/assets/icons/down-arrow.svg" width="8px" />
                            }
                        </button> */}


                        {/* <FixedView ref={(el) => (this.secondView = el)} nodeRef={this.secondCurrentNode} topOffset={0} xOffset={-10} zIndex={10}>
                            <div className="flexcc flex-column" style={{ backgroundColor: '#ffffff', boxShadow: '0px 0px 10px #10101010', borderRadius: 4, cursor: 'pointer', width: 50 }}>
                                <div className="action py-1" style={{}} onClick={() => this.changeAction('and', this.props.prop.id)}>
                                    <p className="text-smaller px-1">{translate('and')}</p>
                                </div>
                                <div className="action py-1" style={{}} onClick={() => this.changeAction('or', this.props.prop.id)}>
                                    <p className="text-smaller px-1">{translate('or')}</p>
                                </div>
                            </div>
                        </FixedView> */}

                        {data.conditions && Object.values(data.conditions).map((prop, index) => {
                            if (prop) {
                                if (prop.action) {
                                    return (
                                        <div key={prop.id} className="pld-2">
                                            <div className=" pld-3 pb-2 my-2 pt-2" style={{ background: '#fff', color: '#000', borderLeft: '1px solid rgba(0,0,0,0.1)', borderBottom: '1px solid rgba(0,0,0,0.1)', border: '1px solid rgba(0,0,0,0.1)', width: "100%", borderRadius: '8px' }} >
                                                {this.renderGroup(prop, [...parents, data.id], level + 1)}
                                            </div>
                                        </div>
                                    )
                                }
                                else {
                                    return (
                                        <div className="" style={{}} key={prop.id} >
                                            <FilterItems calc={this.state.calc} selectedChoose={this.state.selectedChoose} label={this.state.labela} calca={this.state.calca} setData={this.setData} getlabel={this.getLabel} changeAction={this.changeAction} items={this.state.items} renderGroup={this.renderGroup} removeRow={this.removeRow} optionsList={this.props.optionsList} prop={prop} index={index} level={level} data={data} parents={parents} openInput={this.openInput} conditionsLength={Object.values(data.conditions)?.length} changeInputValue={this.changeInputValue} fullParams={this.props.fullParams ?? this.props.params} setLastClicked={this.setLastClicked} lastClicked={this.state.lastClicked} variables={this.props.variables} />
                                        </div>

                                    )
                                }

                            }

                        }
                        )}
                    </div >
                    {data.action && (
                        <div className="flexc pt-1" style={{ opacity: '100%' }} >
                            <div ref={el => this['add-' + data.id] = el} className="w-100">
                                <div className="flexc w-100">
                                    <button className="flexc" style={{ border: '0px solid #007aff', width: level > 0 ? '30%' : '50%', maxWidth: 75, }} onClick={() => this.doAdd('con', { level: level, groupId: data.id, parents: parents })}>
                                        <img className="" src="/assets/icons/plus-blue.svg" width="16px" />
                                        <p className="pld-1 text-smaller font-size-12 email-des" style={{ color: "#007aff", width: '90%' }}>{translate('Condition')}</p>
                                    </button>

                                    <button className="flexc mx-2" style={{ border: '0px solid #007aff', width: level > 0 ? '30%' : '50%', maxWidth: 110, }} onClick={() => this.doAdd('group', { level: level, groupId: data.id, parents: parents })}>
                                        <img className="" src="/assets/icons/plus-blue.svg" width="16px" />
                                        <p className="pld-1 text-smaller font-size-12 email-des" style={{ color: "#007aff", width: '90%' }}>{translate('Condition group')}</p>
                                    </button>

                                    {level > 0 && (
                                        <button className="mrd-3 flexc" style={{ border: '0px solid #007aff', width: '30%', maxWidth: 90 }} onClick={() => this.removeRow(data.id, null, parents, level)}  >
                                            <p className="text-smaller text-semibold email-des" style={{ color: "#888", width: '100%' }}>{translate("Remove group")}</p>
                                        </button>
                                    )}

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )
        }
    }


    // generateVisual(data) {
    //     if (data) {
    //         return this.generateGroupVisual(data.root)
    //     } else {
    //         return " "
    //     }
    // }

    // generateGroupVisual(group) {
    //     let text = ""
    //     if (typeof group.conditions == 'object') {
    //         text = '('
    //         Object.values(group.conditions).forEach((oneInGroup, index) => {

    //             if (index != 0) {
    //                 if (group.action == 'and') {
    //                     text = text + " & "
    //                 }
    //                 if (group.action == 'or') {
    //                     text = text + " | "
    //                 }
    //             }

    //             if (oneInGroup.action) {
    //                 text = text + this.generateGroupVisual(oneInGroup)
    //             } else {

    //                 text = text + oneInGroup.source + " " + oneInGroup.operator + " " + oneInGroup.target
    //             }
    //         });
    //         text = text + ")"
    //     }
    //     return text
    // }


    // open = () => {
    //     this.filterEditor.open()
    // }

    render() {

        return (
            <>
                <div className="w-100" ref={el => this.filterEditor = el}  >

                    {/* {this.state.paramsInfo && (
                        <button className=" font-size-12 white px-2 py-1 br-20 text-semibold flexc" style={{ top: this.state.paramsInfo?.position?.top, left:  this.state.paramsInfo?.position?.left, zIndex: 1, backgroundColor: '#000000dd', position: 'fixed' }}>
                            <p className="">{translate("Params")}</p>
                            <img className="mld-1 invert " style={{ marginTop: 2 }} src="/assets/icons/useful/sort-down.png" alt="" height={8} />
                        </button>
                    )} */}


                    <div className=" pb-2 w-100 scroll-no-scrollbar" style={{}} >
                        {this.state.data && (
                            <div className="text-start ">
                                {this.renderGroup(this.state.data?.root, [], 0)}
                            </div>
                        )}
                    </div>
                </div>


            </>
        )
    }
}

export default FilterEditorInput;